import React, { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { useHistory } from 'react-router';
import { useSelector } from 'react-redux';
import {
  Container,
} from '@uncinc/uncinc-react-kitchen-sink';
import {
  CoreLink,
} from '@uncinc/react-drupal-core';
import { useTranslation } from 'react-i18next';
import LogoImageVNL from '../../assets/images/VNL_logo.svg';
import { ROUTE_NEWSLETTER_SETTINGS } from '../../config/routes';

import SpotlerSubscriptionForm from '../../components/Form/SpotlerSubscriptionForm';

import { DEFAULT_LANGUAGE } from '../../config/constants';

const SpotlerSubscription = () => {
  const PAGE_TITLE = 'Nieuwsbrief | VeiligheidNL';
  const history = useHistory();
  const loggedIn = useSelector((state) => state.getIn(['login', 'loggedIn'], null));
  const { t } = useTranslation();
  const [formSuccess, setFormSuccess] = useState(false);

  useEffect(() => {
    if (loggedIn) {
      history.push(ROUTE_NEWSLETTER_SETTINGS);
    }
  }, [loggedIn]);

  return (
    <div>
      <Helmet
        htmlAttributes={{
          lang: DEFAULT_LANGUAGE,
        }}
      >
        <title>{PAGE_TITLE}</title>
      </Helmet>
      <Container small>
        <div className="FormPage PageSubscribeNewsletter PageMinimal" id="main">
          <div className="PageMinimal__top">
            <CoreLink className="Logo" href="/">
              <img src={LogoImageVNL} alt="VeiligheidNL" />
            </CoreLink>
            <h1>{t(`form.newsletter.${formSuccess ? 'create_success' : 'title'}`)}</h1>
          </div>
          <div className="PageMinimal__content">
            {formSuccess ? (
              <div>
                {t('form.newsletter.create_success_message')}
              </div>
            ) : (
              <>
                <p>{t('spotler.newsletter_notice')}</p>
                <SpotlerSubscriptionForm
                  hideEmail={false}
                  onSuccess={(isNew) => {
                    setFormSuccess(true);
                    // Check
                    let gtmEventName = 'spotler_subscription_update';
                    if (isNew) {
                      gtmEventName = 'spotler_subscription_create_non_logged_in';
                      if (loggedIn) {
                        gtmEventName = 'spotler_subscription_create_logged_in';
                      }
                    }
                    // Push custom GTM event
                    window.dataLayer = window.dataLayer || [];
                    window.dataLayer.push({
                      event: 'spotler_subscription_create_non_logged_in',
                    });
                  }}
                />
              </>
            )}
          </div>
        </div>
      </Container >
    </div >
  );
};

export default SpotlerSubscription;
